module.exports = __webpack_public_path__ + "static/media/SCR-C-051.3f56f469.mp3";